module.exports = __webpack_public_path__ + "static/media/prize-1.166f682a.png";